<template>
  <div>
    Homepage
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      //
    }
  },
  created() {
    // disable /homepage for now
    window.location.href = '/dashboard';
  },
  methods: {}
}
</script>
